import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { triggerTradeSellerLearnMoreLinkClickedEvent } from 'Services/analytics/events';
import ROUTES from 'Utilities/routes';

import LocalTexts from '../TradeSellerDetailsSection.texts.json';

import styles from './TradeDescription.module.scss';

const LocalT = new MDText(LocalTexts);

export const TradeDescription: React.FC = () => {
	const { id } = useVehicleData();

	const onClick = () => {
		triggerTradeSellerLearnMoreLinkClickedEvent(id);
	};

	return (
		<>
			{LocalT.translate('description')}
			<span className={styles.link}>
				<Hyperlink
					data-thc-hyperlink
					inherit
					href={ROUTES.MOTORWAY_TRADE.href}
					label={LocalT.translate('learnMoreLink')}
					onClick={onClick}
					size="small"
					target="_blank"
				/>
			</span>
		</>
	);
};
